import React from "react";

export interface CardBodyProps {
  /**
   * Content inside the card body, can be text or JSX elements.
   */
  children: React.ReactNode;
}

/**
 * The body section of the card for primary content, descriptions, or supporting information.
 */
export const CardBody: React.FC<CardBodyProps> = ({ children }) => {
  return <div className="p-3 sm:p-4 flex flex-col min-h-0 h-full">{children}</div>;
};

export default CardBody;
